<template>
  <div class="wrapper account-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("ACCOUNT") }}</h1>
          <div class="tab-area">
            <div
              class="tab link-over"
              v-on:click="isSelect('1')"
              v-bind:class="{ active: isActive === '1' }"
            >
              {{ $t("Registration information") }}
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('2')"
              v-bind:class="{ active: isActive === '2' }"
            >
              {{ $t("Contract information") }}
            </div>
          </div>
          <div class="content-area" v-show="isActive === '1'">
            <div class="form">
              <form action="" method="">
                <!-- USER NAME -->
                <div class="input-area">
                  <label class="label" for="account">
                    <input
                      type="text"
                      name=""
                      id="account"
                      :value="$t('Username')"
                      readonly
                    />
                    <span class="group-label">{{ $t("Username") }}</span>
                  </label>
                  <span class="circle done">
                    <span class="bar"></span>
                  </span>
                </div>
                <!-- EMAIL -->
                <div class="input-area password">
                  <label class="label" for="email">
                    <input
                      type="text"
                      name=""
                      id="email"
                      :value="$t('Email address')"
                    />
                    <span class="group-label">{{
                      $t("E-MAIL ADDRESS CHANGE")
                    }}</span>
                  </label>
                  <span class="edit" v-on:click="show2">{{ $t("Edit") }}</span>
                  <span class="circle">
                    <span class="bar"></span>
                  </span>
                </div>
                <!-- EMAIL -->
                <div class="input-area password">
                  <label class="label" for="password">
                    <input type="text" name="" id="password" value="********" />
                    <span class="group-label">{{ $t("PASSWORD") }}</span>
                  </label>
                  <span class="edit" v-on:click="show">{{ $t("Edit") }}</span>
                  <span class="circle done">
                    <span class="bar"></span>
                  </span>
                </div>
                <!-- PHONE NUMBER -->
                <div class="input-area">
                  <label class="label" for="phone_number">
                    <input
                      type="text"
                      name=""
                      id="phone_number"
                      :value="$t('PHONE NUMBER')"
                      placeholder=""
                    />
                    <span class="group-label">{{ $t("PHONE NUMBER") }}</span>
                  </label>
                  <span class="circle">
                    <span class="bar"></span>
                  </span>
                </div>
                <!-- GOOGLE AUTHENTICATOR -->
                <div class="input-area password">
                  <label class="label" for="google">
                    <input type="text" name="" id="google" placeholder="" />
                    <span class="group-label">{{
                      $t("Two-factor authentication")
                    }}</span>
                  </label>
                  <router-link to="./authentication" class="edit link-over">{{
                    $t("Authenticate")
                  }}</router-link>
                  <span class="circle">
                    <span class="bar"></span>
                  </span>
                </div>
                <!-- REFERRAL CODE -->
                <div class="input-area">
                  <label class="label" for="referal_code">
                    <input
                      type="text"
                      name=""
                      id="referal_code"
                      :value="$t('REFERRAL CODE')"
                      readonly
                    />
                    <span class="group-label">{{ $t("REFERRAL CODE") }}</span>
                  </label>
                  <span class="circle done">
                    <span class="bar"></span>
                  </span>
                </div>
              </form>
            </div>
          </div>
          <div class="content-area" v-show="isActive === '2'">
            <div class="form">
              <form>
                <div class="img">
                  <img src="../assets/img/account-pdf-img.svg" alt="" />
                </div>
                <!-- USER NAME -->
                <div class="input-area">
                  <label class="label" for="name">
                    <input
                      type="text"
                      name=""
                      id="name"
                      :value="$t('Name')"
                      readonly
                    />
                    <span class="group-label">{{ $t("Name") }}</span>
                  </label>
                  <span class="circle done">
                    <span class="bar"></span>
                  </span>
                </div>
                <!-- PHONE NUMBER -->
                <div class="input-area">
                  <label class="label" for="phone_number">
                    <input
                      type="text"
                      name=""
                      id="phone_number"
                      :value="$t('PHONE NUMBER')"
                      placeholder=""
                      readonly
                    />
                    <span class="group-label">{{ $t("PHONE NUMBER") }}</span>
                  </label>
                  <span class="circle done">
                    <span class="bar"></span>
                  </span>
                </div>
              </form>
            </div>
          </div>
          <div class="terms-link">
            <router-link to="/terms" class="link-over">{{
              $t("Terms of service")
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <modal
      name="resetModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box notice-box">
        <div class="text-area">
          <h2>{{ $t("Set a new password") }}</h2>
          <form>
            <div class="input-area password">
              <label class="label" for="password1">
                <input type="text" name="" id="password1" placeholder=" " />
                <span class="group-label">{{
                  $t("Enter your current password")
                }}</span>
              </label>
            </div>
            <div class="input-area password">
              <label class="label" for="password2">
                <input type="text" name="" id="password2" placeholder=" " />
                <span class="group-label">{{ $t("Enter new password") }}</span>
              </label>
            </div>
            <div class="input-area password">
              <label class="label" for="password3">
                <input type="text" name="" id="password3" placeholder=" " />
                <span class="group-label">{{
                  $t("Re-enter new password")
                }}</span>
              </label>
            </div>
          </form>
        </div>
        <div class="btn">
          <button v-on:click="hide" type="button" class="link-over">
            {{ $t("Complete the settings") }}
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="emailModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box notice-box">
        <div class="text-area">
          <form>
            <div
              class="txt"
              v-html="
                $t(
                  'URL for change has been sent to your registered e-mail address.'
                )
              "
            ></div>
          </form>
        </div>
        <div class="btn">
          <button v-on:click="hide2" type="button" class="link-over">
            {{ $t("Close") }}
          </button>
        </div>
      </div>
    </modal>

    <Footer title="Account" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Account",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Account",
      isActive: "1",
    };
  },
  methods: {
    isSelect: function (num) {
      this.isActive = num;
    },
    show: function () {
      this.$modal.show("resetModal");
    },
    hide: function () {
      this.$modal.hide("resetModal");
    },
    show2: function () {
      this.$modal.show("emailModal");
    },
    hide2: function () {
      this.$router.push("/changeemail");
      this.$modal.hide("emailModal");
    },
  },
  computed: {},
  mounted: function () {},
};
</script>
